import TextSection from '../CustomizeTextSection';
import CodeSection from '../CustomizeCodeSection';
import MultiLangSection from '../MultiLangSection';
import InfoSection from '../CustomizeInfoSection';
import TableSection from '../CustomizeTableComponent';
import ImageDescriptionList from '../../GetStarted/ImageDescriptionList';
import NumberedList from '../../GetStarted/NumberedList';
import CodeTabsSection from '../CustomizeCodeTabsSection';
import { AccordionWrapper } from '../../../components/Accordion';

const componentMap = new Map();

componentMap.set('customizePageTextContent', TextSection);
componentMap.set('customizePageCodeContent', CodeSection);
componentMap.set('customizePageTabbedCodeContent', CodeTabsSection);
componentMap.set('customizePageInfoContent', InfoSection);
componentMap.set('customizePageTableContent', TableSection);
componentMap.set('customizeImageDescriptionList', ImageDescriptionList);
componentMap.set('customizeNumberedList', NumberedList);
componentMap.set('customizeSectionStepMultiLanguage', MultiLangSection);
componentMap.set('accordion', AccordionWrapper);

export default componentMap;
